<template>
	<v-menu v-model="menu" :attach="overlayTarget || undefined" :close-on-content-click="false" :disabled="disabled" location="bottom start" min-width="auto" class="date-picker-control__menu">
		<template #activator="{ props: activatorProps }">
			<v-text-field v-bind="{ ...$attrs, ...activatorProps }" density="comfortable" :model-value="display" :label="label" :disabled="disabled" :clearable="clearable && !disabled && !!modelValue" readonly prepend-inner-icon="event" variant="outlined" class="date-picker-control" @click:clear="emit('update:modelValue', '')" />
		</template>
		<v-date-picker :model-value="selected" :min="minDate" :max="maxDate" :allowed-dates="allowedDates" color="primary" first-day-of-week="1" show-adjacent-months hide-header @update:model-value="pick" />
	</v-menu>
</template>

<script setup>
import { computed, inject, ref } from 'vue';
import { formatDate, parseInputDate, toInputDateValue } from '@/utils/core/format';

defineOptions({ inheritAttrs: false });

const props = defineProps({
	modelValue: { type: String, default: '' },
	label: { type: String, default: '' },
	min: { type: String, default: '' },
	max: { type: String, default: '' },
	allowedDates: { type: Function, default: undefined },
	disabled: { type: Boolean, default: false },
	clearable: { type: Boolean, default: false },
});
const emit = defineEmits(['update:modelValue']);

const overlayTarget = inject('overlayTarget', null);
const menu = ref(false);

const selected = computed(() => parseInputDate(props.modelValue));
const display = computed(() => (selected.value ? formatDate(selected.value) : ''));
const minDate = computed(() => parseInputDate(props.min) || undefined);
const maxDate = computed(() => parseInputDate(props.max) || undefined);

function pick(value) {
	menu.value = false;
	const next = toInputDateValue(value);
	if (next && next !== props.modelValue) emit('update:modelValue', next);
}
</script>
